import * as Event from '../tools/Event';
import Flickity from 'flickity';


export const init = () => {
	const elements = [...document.querySelectorAll('.js-carousel-img')];

	const OPTIONS = {
		groupCells: true,
		pageDots: false,
		prevNextButtons: false,
		wrapAround: true,
	};

	const init = (element) => {
		const carousel = new Flickity(element, OPTIONS);
		const parentNode = element.parentNode;
		const prev = parentNode.querySelector('.c-carousel__prev');
		const next = parentNode.querySelector('.c-carousel__next');
		const pager = parentNode.querySelector('.c-carousel__pager');
		const numOfSlides = carousel.slides.length;

		const setPager = (index = 1) => pager.innerText = `${index}/${numOfSlides}`;

		setPager();

		carousel.on('select', () => {
			const index = carousel.selectedIndex + 1;

			setPager(index);
		});

		Event.on(next, 'click', (event) => {
			event.preventDefault();
			carousel.next();
		});

		Event.on(prev, 'click', (event) => {
			event.preventDefault();
			carousel.previous();
		});
	};


	elements.forEach(init);
};



// WEBPACK FOOTER //
// ./src/js/components/carouselImg.js